import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { purchases } from '../data/purchases';
import { BRAND } from '../data/site';
export function PurchasePopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Mostrar el primer popup después de 5 segundos
    const initialDelay = setTimeout(() => {
      setIsVisible(true);

      // Ocultar después de 5 segundos
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    }, 5000);

    // Luego, repetir cada 15 segundos
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
      setIsVisible(true);

      // Ocultar después de 5 segundos
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    }, 15000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  const purchase = purchases[currentIndex];
  return <div className="pointer-events-none fixed bottom-4 left-4 right-4 z-50 flex justify-center sm:bottom-6 sm:left-6 sm:right-auto sm:justify-start" data-id="element-145" data-mp="116w7ykamj3cs">
      <AnimatePresence data-id="element-146" data-mp="1fuhaod3l70k6">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-[330px] items-center gap-3 rounded-2xl border border-gold-200/60 bg-cream p-3 shadow-[0_20px_40px_-15px_rgba(14,35,21,0.35)] sm:max-w-sm sm:gap-4 sm:p-4" data-id="element-147" data-mp="1fxn0juk1i6gy">
            <div className="relative flex-none" data-id="element-148" data-mp="28k7r4ssoyejg">
              <img src={BRAND.ebookMockup} alt="" className="h-12 w-11 object-contain drop-shadow-md sm:h-14 sm:w-12" data-id="element-149" data-mp="28iwncsz8x6sc" />
              <div className="absolute -bottom-1 -right-1 rounded-full bg-cream p-0.5" data-id="element-150" data-mp="23nhekfg3i12s">
                <CheckCircle2Icon className="h-4 w-4 text-sage-600" data-id="element-151" data-mp="2aobbwi679qtv" />
              </div>
            </div>
            <div className="flex-1" data-id="element-152" data-mp="2fpqywfrxu7ew">
              <p className="text-[12.5px] leading-snug text-ink-soft sm:text-[13px]" data-id="element-153" data-mp="2km7prhqiuzvo">
                <strong className="font-semibold text-sage-800" data-id="element-154" data-mp="2plkanwxu1wvm">{purchase.name}</strong> de{' '}
                <strong className="font-semibold text-sage-800" data-id="element-155" data-mp="1ry3duehcxqkj">{purchase.location}</strong>
              </p>
              <p className="mt-0.5 text-[12px] text-ink-light" data-id="element-156" data-mp="1wwwswbcalpmt">
                Adquirió el Manual de Esferas Navideñas
              </p>
              <p className="mt-1 text-[10.5px] font-medium uppercase tracking-wider text-terracotta-500" data-id="element-157" data-mp="21vhnnv8rzh3v">
                {purchase.timeAgo}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}